import { useRef } from "react";
import { IconButton } from "@mui/material";
import { FaWhatsapp } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import actions from "store/actions";
import { State } from "store/reducers";
import Spinner from "Components/Spinner";
import { DasState } from "../../../../store/reducers/das";
import { removeDiacritics } from "helpers/string";

import XLSX from "xlsx";
import { exportToExcel } from "Components/Report/export";

function SendDases({ load }: any) {
	const dispatch = useDispatch<any>();

	const { loading } = useSelector<State, DasState>(s => s.das);

	const inputFile: any = useRef<HTMLInputElement>(null);

	const openSelectFile = () => {
		if (inputFile.current) {
			inputFile.current.click();
		}
	};

	const handleFileSelected = (e: any) => {
		const file = e.target.files[0];

		if (!file) return;

		e.target.value = null;

		const reader = new FileReader();
		const rABS = !!reader.readAsBinaryString;
		reader.onload = (e: any) => {
			/* Parse data */
			const bstr = e.target.result;
			const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
			/* Get first worksheet */
			const wsname = wb.SheetNames[0];
			const sheet: any = wb.Sheets[wsname];

			const ref = XLSX.utils.decode_range(sheet["!ref"]);

			for (let C = ref.s.c; C <= ref.e.c; ++C) {
				const cell = sheet[XLSX.utils.encode_cell({ r: ref.s.r, c: C })];

				if (cell && cell.t === "s") {
					cell.v = removeDiacritics(cell.v.trim().toLowerCase());

					if (cell.w) cell.w = removeDiacritics(cell.w.trim().toLowerCase());
				}
			}

			const json = XLSX.utils.sheet_to_json(sheet);

			const data = json.map((c: any) => ({
				name: c["nome"] || c.name,
				cnpj: String(c["cnpj"])?.match(/\d/g)?.join(""),
				year: c["ano"] || c.year,
				phoneNumber: String(c["telefone"] || c.phoneNumber)
					?.match(/\d/g)
					?.join(""),
				email: c.email
			}));

			dispatch(
				actions.dasn.sendDasn(data, (err, data: any) => {
					if (err) {
						if (typeof err !== "string") err = JSON.stringify(err);
						alert(err);
					} else {
						exportToExcel(
							[
								{ id: "name" },
								{ id: "cnpj" },
								{ id: "year" },
								{ id: "phoneNumber" },
								{ id: "email" },
								{ id: "status" }
							],
							data,
							"Dasnes enviados"
						);

						load();
					}
				})
			);
		};

		if (rABS) reader.readAsBinaryString(file);
		else reader.readAsArrayBuffer(file);

		inputFile.current.value = null;
	};

	return (
		<div>
			{loading.send ? (
				<Spinner size={24} />
			) : (
				<IconButton onClick={openSelectFile}>
					<FaWhatsapp />
				</IconButton>
			)}
			<input
				ref={inputFile}
				style={{ display: "none" }}
				type="file"
				accept="application/excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				onChange={handleFileSelected}
			/>
		</div>
	);
}

export default SendDases;
